import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FlavourNoteOrderUiStore, CaskUiStore, SessionStore } from 'stores';
import OrderComplete from 'components/OrderComplete';
import LoadingSplash from 'components/Loading/LoadingSplash';
import { Redirect } from 'react-router';

interface Props {
  flavourNoteOrderUiStore?: FlavourNoteOrderUiStore;
  caskUiStore?: CaskUiStore;
  sessionStore?: SessionStore;
}

@inject('flavourNoteOrderUiStore', 'caskUiStore', 'sessionStore')
@observer
class FlavourNoteOrderCompleteContainer extends Component<Props, {}> {
  get store() {
    return this.props.flavourNoteOrderUiStore!;
  }
  
  get cask() {
    return this.props.caskUiStore!.cask;
  }

  get orderId() {
    return this.store.orderId;
  }

  get email() {
    return this.props.sessionStore!.user.email;
  }

  render() {
    if (!this.orderId) {
      return <Redirect to={`/cask/${this.cask.id}/orders/flavour-note`} />;
    }
    return (
      <div>
        {this.store.orderIsComplete ?
          <OrderComplete
            backButtonPrimary={true}
            orderId={this.orderId} 
            email={this.email}
            textIds={{
              title: 'orders.flavourNote.complete.title',
              summary: 'orders.flavourNote.complete.orderCompleteText',
              order: 'orders.flavourNote.complete.orderIdLabel',
              back: 'orders.flavourNote.complete.backButton',
            }}
            backRoute={`/cask/${this.cask.id}`}
          />
        :
          <LoadingSplash />
        }
      </div>
    );
  }
}

export default FlavourNoteOrderCompleteContainer;